import { Check } from 'lib/utils/formValidation/formValidation';

const isValidLongitude: Check = (value) =>
  value != null && !Number.isNaN(Number(value)) && Number(value) >= -180 && Number(value) <= 180;

export default isValidLongitude;
